// extracted by mini-css-extract-plugin
export default {"Blockquote":"index-module--Blockquote--buTZk","Blockquote__icon":"index-module--Blockquote__icon--KCiFU","Blockquote__author":"index-module--Blockquote__author--Rsrte"};